import { createAction, props } from '@ngrx/store';
import { Profile } from '@fantaz/shared/data-access/models';

export const loadProfile = createAction('[Profile Page] Init');

export const loadProfileSuccess = createAction(
  '[Profile/API] Load Profile Success',
  props<{ profile: Profile }>(),
);

export const loadProfileFailure = createAction(
  '[Profile/API] Load Profile Failure',
  props<{ error: any }>(),
);

/**
 * Update actions to update the profile
 */
export const update = createAction(
  '[Profile Action] Update Profile',
  props<{
    payload: Partial<Profile>;
    options?: { silent: boolean; msg?: string };
  }>(),
);

export const updateProfileSuccess = createAction(
  '[Profile/API] Update Profile Success',
  props<{ response?: any; profile?: Partial<Profile> }>(),
);

export const updateProfileFailure = createAction(
  '[Profile/API] Update Profile Failure',
  props<{ error: any }>(),
);

export const updateUserContactAttribute = createAction(
  '[Profile Action] Update User Contact Attribute',
  props<{
    payload: { email?: string; phone_number?: string };
  }>(),
);

export const updateUserContactAttributeSuccess = createAction(
  '[Profile/API] Update User Contact Attribute Success',
  props<{ message: string }>(),
);

export const updateUserContactAttributeFailure = createAction(
  '[Profile/API] Update User Contact Attribute Failure',
  props<{ error: any }>(),
);
